import React from 'react';
import { Container, Button } from '@lightful/ray';
import { useTranslation } from 'react-i18next';
import { track, EVENTS } from '../../utils/analytics';

import './TimedOutError.scss';

const TimedOutError = () => {
  const { t } = useTranslation();

  document.body.classList.add('timed-out');

  return (
    <Container className="h-100">
      <div className="d-flex justify-content-center p-4 h-100 align-items-center">
        <div style={{ maxWidth: '440px' }}>
          <h1 className="mb-2 mt-0">{t('timeOut:title')}</h1>
          <p className="mb-3 mt-0">{t('timeOut:message')}</p>
          <Button
            onClick={() => {
              track(EVENTS.CLICK_TO_REFRESH_BILLING_FAIL);
              window.location.reload();
            }}
          >
            {t('timeOut:button')}
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default TimedOutError;
